
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDieselGeneratorDc as ObiDieselGeneratorDcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diesel-generator-dc.js';
 
 
 

 
 export const ObiDieselGeneratorDc = createComponent({
   react: React,
   tagName: 'obi-diesel-generator-dc',
   elementClass: ObiDieselGeneratorDcElement,
   events: {
     
   }
  });
 
 